import { observable, action } from 'mobx'
import Api from '@api/taskOfOpeningShop'
import MemberApi from '@api/siYiTeamGroupMember'
import { isSiYiTeam } from '@util'

// 发布作品任务id
export const PUBLISH_WORK_TASK_ID = 20

class Store {
  @observable data = {}

  @observable memberList = [] // 成员列表，司仪团队->发布作品前校验成员列表是否为空

  // 获取成员数据
  @action
  getMemberList = async () => {
    const { success, data } = await MemberApi.getMemberList()
    if (success) {
      this.memberList = data.list
    }
  }

  @action
  getData = async () => {
    const { data, success } = await Api.details({ id: this.id })
    if (success) {
      this.data = data || {}
      // 如果是司仪团队，并且存在发布作品的任务，则去获取成员列表, 点击发布时校验成员列表是否为空
      if (
        isSiYiTeam() &&
        data?.taskList?.find(item => item.id === PUBLISH_WORK_TASK_ID)
      ) {
        this.getMemberList()
      }
    }
  }

  @observable visible = false
  @action
  showModal = () => {
    this.visible = !this.visible
  }

  @action
  finishTask = async () => {
    const { success } = await Api.finishOpeningStage()
    if (success) {
      window.location.reload()
    }
  }
}
export default Store
